import { useEffect, useCallback } from 'react';
import { Outlet, useRoutes } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@store';
import { setActivePermissions } from './store/dictionaries/slices';
import {
  useLazyGetMessagesPermissionsQuery,
  useLazyGetMessagingWhitelabelQuery,
} from './store/dictionaries/services';
import MessagesMain from './routes/messages-main';
import MessagesRequests from './routes/messages-requests';
import Messages from './hoc/messages';

import ROUTES from './routes';

export const routes = {
  path: ROUTES.MESSAGES,
  element: <Messages />,
  children: [{ ...MessagesMain }, { ...MessagesRequests }],
};

const MessagesRoutes = () => {
  const elements = useRoutes([
    {
      path: '/',
      element: (
        <Outlet
          context={{
            connectionStatus: null,
            sendMessage: null,
            messagesScrollRef: null,
          }}
        />
      ),
      children: [{ ...routes }],
    },
  ]);

  const dispatch = useAppDispatch();

  const { activePermissions, whitelabel } = useAppSelector(
    (state) => state.messagesDictionaries,
  );

  const [getMessagesPermissions] = useLazyGetMessagesPermissionsQuery();
  const [getMessagingWhiteLabel] = useLazyGetMessagingWhitelabelQuery();

  const getMessagesPermissionsAction = useCallback(() => {
    getMessagesPermissions();
  }, []);

  const permissions = JSON.parse(
    localStorage.getItem('activePermissions') as string,
  );

  useEffect(() => {
    const companyName = localStorage.getItem('companyName');

    if (!companyName) {
      getMessagingWhiteLabel();
    }
  }, []);

  useEffect(() => {
    if (whitelabel) {
      localStorage.setItem('companyName', whitelabel?.data?.value?.companyName);
    }
  }, [whitelabel]);

  useEffect(() => {
    if (permissions && !activePermissions) {
      dispatch(setActivePermissions(permissions));
    } else if (!permissions && !activePermissions) {
      getMessagesPermissionsAction();
    }
  }, [permissions, getMessagesPermissionsAction, dispatch, activePermissions]);

  return elements;
};

export default MessagesRoutes;
